import React from "react";
import { techIcons } from "../data/techIcons";

export default function TechnologyList({ technologyList }) {
    return technologyList.map((technology) => (
        <React.Fragment key={technology}>
            <img
                src={techIcons[technology]}
                alt={technology}
                className="w-[30px] h-[30px]"
            />
        </React.Fragment>
    ));
}
